import { createTheme } from '@mui/material/styles';

// Example: add 'lime' and 'darkGreen' as custom colors in palette
declare module '@mui/material/styles' {
  interface Palette {
    lime: Palette['primary'];
    darkGreen: Palette['primary'];
  }
  interface PaletteOptions {
    lime?: PaletteOptions['primary'];
    darkGreen?: PaletteOptions['primary'];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C423C',  // existing App-link color
    },
    lime: {
      main: '#bfd200',  // lime green
    },
    darkGreen: {
      main: '#2C423C',  // dark green
    },
  },
  typography: {
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
      textTransform: 'uppercase',
      color: '#2C423C',
    },
    h4: {
        fontSize: '1.5rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        color: '#2C423C',
    }
  },
});

export default theme;